import React, { Component } from 'react';
import styled from 'styled-components';

// utils //
import history from 'utils/history';

// Components //
import Container from 'components/Container';
import Subtitle from 'components/Subtitle';
import Title from 'components/Title';
import Text from 'components/Text';
import View from 'components/View';
import Button from 'components/Button';
import WelcomeIllustration from 'components/WelcomeIllustration';

const Root = styled(View)`
  z-index: 0;
  flex: 1;
`;

const Wrapper = styled(Container)`
  flex: 1;
  padding-top: 100px;
  justify-content: flex-start;
  align-items: flex-start;
`;

const Content = styled(View)`
  & > ${ Subtitle } {
    margin-bottom: 8px;
  }
  & > ${ Title } {
    margin-bottom: 16px;
  }
  & > ${ Text } {
    max-width: 531px;
  }
`;

const StartNow = styled(Button)`
  margin-top: 98px;
  align-self: flex-start;
`;

class Welcome extends Component {

  static propTypes = {

  };

  _startTutorial = () => {
    history.push('/step-1')
  }

  render() {
    return (
      <Root>
        <Wrapper>
            <Content>
              <Subtitle>
                API Tutorial
              </Subtitle>
              <Title
                size={51}
              >
                Chat Messaging
              </Title>
              <Text
                size={22}
              >
                This tutorial will quickly bring you up to speed on how to use the Chat API. If you haven’t seen our <a rel="noopener noreferrer" target="_blank" href="https://getstream.github.io/stream-chat-react/">React Chat Components</a> yet, you’ll want to give this tutorial a try first.
              </Text>
              <StartNow
                large
                color="dark"
                label="Start Now"
                onClick={this._startTutorial}
              />
            </Content>
        </Wrapper>
        <WelcomeIllustration />
      </Root>
    );
  }
}

export default Welcome;
